import i18next from 'i18next';
import { TableFilter } from 'src/components/ui/Table/Table.interface';
import { Role } from 'src/store/models/Auth';
import { TicketStatus } from 'src/store/models/Ticket';

export type EmptyTable = {
  [key in TicketStatus]?: {
    title: string;
    subtitle: string;
  };
};

export interface EmptyTables {
  [Role.ADMIN]: EmptyTable;
  [Role.MANUFACTURER]: EmptyTable;
  [Role.SERVICE]: EmptyTable;
}

export const emptyTable: EmptyTables = {
  [Role.ADMIN]: {},
  [Role.MANUFACTURER]: {
    [TicketStatus.UNASSIGNED]: {
      title: i18next.t('dashboard:no_unassigned'),
      subtitle: i18next.t('dashboard:no_unassigned_details'),
    },
    [TicketStatus.TO_DO]: {
      title: i18next.t('tickets:no_assigned'),
      subtitle: i18next.t('tickets:no_assigned_details'),
    },
    [TicketStatus.IN_PROGRESS]: {
      title: i18next.t('tickets:no_in_progress'),
      subtitle: i18next.t('tickets:no_in_progress_details_manu'),
    },
    [TicketStatus.RESOLVED]: {
      title: i18next.t('tickets:no_resolved'),
      subtitle: i18next.t('tickets:no_resolved_details_manu'),
    },
  },
  [Role.SERVICE]: {
    [TicketStatus.TO_DO]: {
      title: i18next.t('dashboard:no_tickets'),
      subtitle: i18next.t('dashboard:no_tickets_details'),
    },
    [TicketStatus.IN_PROGRESS]: {
      title: i18next.t('tickets:no_in_progress'),
      subtitle: i18next.t('tickets:no_in_progress_details'),
    },
    [TicketStatus.RESOLVED]: {
      title: i18next.t('tickets:no_resolved'),
      subtitle: i18next.t('tickets:no_resolved_details'),
    },
  },
};

export interface TableFilters {
  [Role.ADMIN]: TableFilter<TicketStatus>[];
  [Role.MANUFACTURER]: TableFilter<TicketStatus>[];
  [Role.SERVICE]: TableFilter<TicketStatus>[];
}

export const ticketFilters: TableFilters = {
  [Role.ADMIN]: [],
  [Role.MANUFACTURER]: [
    {
      label: i18next.t('common:unassigned'),
      value: TicketStatus.UNASSIGNED,
      color: 'colorRed',
    },
    {
      label: i18next.t('common:assigned'),
      value: TicketStatus.TO_DO,
      color: 'colorBlack',
    },
    {
      label: i18next.t('common:in_progress'),
      value: TicketStatus.IN_PROGRESS,
      color: 'colorYellow',
    },
    {
      label: i18next.t('common:resolved'),
      value: TicketStatus.RESOLVED,
      color: 'colorFumisGreen1',
    },
  ],
  [Role.SERVICE]: [
    {
      label: i18next.t('common:to_do'),
      value: TicketStatus.TO_DO,
      color: 'colorRed',
    },
    {
      label: i18next.t('common:in_progress'),
      value: TicketStatus.IN_PROGRESS,
      color: 'colorYellow',
    },
    {
      label: i18next.t('common:resolved'),
      value: TicketStatus.RESOLVED,
      color: 'colorFumisGreen1',
    },
  ],
};
